import { defineMessages } from 'react-intl';

export default defineMessages({
    Activities: {
        id: 'qnb.spt.SgSptStandardActivitiesModal.Activities',
        defaultMessage: 'Activities'
    },
    Covered: {
        id: 'qnb.spt.SgSptStandardActivitiesModal.Covered',
        defaultMessage: 'Covered'
    },
    Standard: {
        id: 'qnb.spt.SgSptStandardActivitiesModal.Standard',
        defaultMessage: 'as standard'
    },
    Organized: {
        id: 'qnb.spt.SgSptStandardActivitiesModal.Organized',
        defaultMessage: 'if professionally organised'
    },
    Close: {
        id: 'qnb.spt.SgSptStandardActivitiesModal.Close',
        defaultMessage: 'Close'
    },
    NoPersonalLiabilityCover: {
        id: 'qnb.spt.SgSptStandardActivitiesModal.NoPersonalLiabilityCover',
        defaultMessage: '† No Personal Liability cover'
    },
    NoAccidentAndLiabilityCover: {
        id: 'qnb.spt.SgSptStandardActivitiesModal.NoAccidentAndLiabilityCover',
        defaultMessage: '†† No Personal Accident or Personal Liability cover'
    },
    NoResultsFound: {
        id: 'qnb.spt.SgSptStandardActivitiesModal.NoResultsFound',
        defaultMessage: 'No results found'
    },
    ModalTitle: {
        id: 'qnb.spt.SgSptStandardActivitiesModal.ModalTitle',
        defaultMessage: 'Standard Activities Covered'
    }
});
